import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useEffect, useId, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import InputField from "@ingka/input-field";
import ListBox, { MenuItem } from "@ingka/list-box";
import SSRIcon from "@ingka/ssr-icon";
import chevronDownSmall from "@ingka/ssr-icon/paths/chevron-down-small";
import chevronUpSmall from "@ingka/ssr-icon/paths/chevron-up-small";
import { PopOver } from "@pdpp/lib-react";
export const ReasonDropdown = memo(function ReasonDropdown$({ reasons, selectedReason, onReasonChange, className = "", disabled = false, hasError = false, showLabel = false, }) {
    const { t } = useTranslation();
    const uniqueId = useId();
    const inputId = `reason-select-input-${uniqueId}`;
    const listBoxId = `reason-listbox-${uniqueId}`;
    const [showReasonFilter, setShowReasonFilter] = useState(false);
    const reasonInputRef = useRef(null);
    const popoverRef = useRef(null);
    const handleReasonSelect = (reasonId) => {
        onReasonChange(reasonId);
        setShowReasonFilter(false);
    };
    const handleClickAway = (event) => {
        const target = event.target;
        if (reasonInputRef.current && !reasonInputRef.current.contains(target)) {
            setShowReasonFilter(false);
        }
    };
    useEffect(() => {
        if (showReasonFilter === true &&
            reasonInputRef.current &&
            popoverRef.current) {
            const width = reasonInputRef.current.offsetWidth;
            popoverRef.current.style.setProperty("--popover-width", `${width}px`);
        }
    }, [showReasonFilter]);
    const hasReason = selectedReason != null && selectedReason !== "";
    const selectedReasonTitle = hasReason === true
        ? reasons.find((r) => r.id === selectedReason)?.name ??
            t("publishModal.chooseOption")
        : t("publishModal.chooseOption");
    const selectableReasons = reasons.filter((r) => r.name != null && r.name.trim() !== "");
    const popoverClassName = className === "forecast-publish-modal__row-reason-button"
        ? "forecast-publish-modal__row-reason-popover"
        : "forecast-publish-modal__reason-popover";
    const accessibleLabel = t("publishModal.reasonForAdjustments");
    const handleToggle = () => {
        if (disabled === false) {
            setShowReasonFilter((prev) => !prev);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: `${className} ${hasError === true ? `${className}--error` : ""}`, "data-error": hasError === true ? "true" : undefined, ref: reasonInputRef, children: [_jsx(InputField, { id: inputId, type: "text", label: showLabel === true ? accessibleLabel : "", "aria-label": showLabel === false && accessibleLabel, value: selectedReasonTitle, readOnly: true, disabled: disabled, onClick: handleToggle }), _jsx("button", { type: "button", className: "forecast-publish-modal__reason-icon", onClick: handleToggle, disabled: disabled, "aria-expanded": showReasonFilter, "aria-controls": listBoxId, "aria-label": t("publishModal.toggleReasonDropdown"), children: _jsx(SSRIcon, { paths: showReasonFilter === true ? chevronUpSmall : chevronDownSmall }) })] }), showReasonFilter === true &&
                reasonInputRef.current &&
                disabled === false && (_jsx(PopOver, { clickAwayHandler: handleClickAway, onScroll: () => setShowReasonFilter(false), anchorEl: reasonInputRef.current, horizontalPosition: "left", horizontalAlignment: "left", verticalPosition: "bottom", verticalAlignment: "top", children: _jsx("div", { ref: popoverRef, className: popoverClassName, children: _jsxs(ListBox, { id: listBoxId, open: true, value: hasReason === true ? [selectedReason] : [], onChange: (ids) => handleReasonSelect(ids[0] ?? ""), autoFocus: true, children: [_jsx(MenuItem, { id: "", title: t("publishModal.chooseOption"), onClick: () => handleReasonSelect("") }, "none"), selectableReasons.map((reason) => (_jsx(MenuItem, { id: reason.id, title: reason.name ?? "", onClick: () => handleReasonSelect(reason.id) }, reason.id)))] }) }) }))] }));
});
//# sourceMappingURL=ReasonDropdown.js.map